import { FormControl, FormGroup } from '@angular/forms';
import { combineLatest, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { PlanningHasService } from '../services/planning/planning-has.service';
import { UserPlanningService } from '../services/planning/user-planning.service';
import { Utils } from '../utils.class';

export interface LocalUserIsAvailableConfig {
    formGroup: FormGroup;
    ownId?: number;
    beginDateField?: string;
    endDateField?: string;
    userPlanningService: UserPlanningService;
    planningHasService: PlanningHasService;
    planningId?: number;
}

export const localUserIsAvailableValidator = (config: LocalUserIsAvailableConfig) => {
    const {
        formGroup,
        ownId,
        beginDateField = 'begindate',
        endDateField = 'enddate',
        userPlanningService,
        planningHasService,
    } = config;

    return (input: FormControl) => {
        if (formGroup.get(beginDateField)?.value && formGroup.get(endDateField)?.value && input.value) {
            const otherFormGroupsPhe = formGroup.parent?.parent;
            const otherFormGroupsUp = formGroup.parent?.parent?.parent?.get('employeePlanning');
            const begindate = Utils.getTimeOrNull(formGroup.get(beginDateField).value);
            const enddate = Utils.getTimeOrNull(formGroup.get(endDateField).value);

            let res = false;

            return combineLatest([
                userPlanningService.getFilteredList(Utils.newDate(begindate), Utils.newDate(enddate)),
                planningHasService.getFilteredList(Utils.newDate(begindate), Utils.newDate(enddate)),
            ]).pipe(
                first(),
                map(([userPlannings, planningHas]) => {
                    [
                        ...planningHas.filter(ph => ph.planning_id !== config.planningId),
                        ...otherFormGroupsPhe.value.map(ph => ph.phe),
                    ].forEach(planningHas => {
                        if (planningHas.id !== ownId) {
                            if (planningHas.driver_user_id === input.value) {
                                if (
                                    Utils.getTimeOrNull(planningHas.begindate) < enddate &&
                                    Utils.getTimeOrNull(planningHas.enddate) > begindate
                                ) {
                                    res = true;
                                }
                            }
                        }
                    });

                    [
                        ...userPlannings.filter(up => up.planning_id !== config.planningId),
                        ...otherFormGroupsUp.value,
                    ].forEach(userPlanning => {
                        if (userPlanning.user_id === input.value) {
                            if (
                                Utils.getTimeOrNull(userPlanning.begindate) < enddate &&
                                Utils.getTimeOrNull(userPlanning.enddate) > begindate
                            ) {
                                res = true;
                            }
                        }
                    });
                    return res ? { notAvailable: res } : null;
                })
            );
        }
        return of(null);
    };
};
